module.exports = __webpack_public_path__ + "img/red-pita-00.beb428fb.png";